module.exports = __webpack_public_path__ + "static/telecom-e36b1e25507fd77cdc3487795968dcff.jpg";